import actionCreatorFactory from "typescript-fsa";
import { Tenant } from "./types";

const actionCreator = actionCreatorFactory("@@Tenant");

export const tenantActions = {
  fetchTenants: actionCreator.async<{}, { tenants: Tenant[] }>("FETCH_TENANTS"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
